/**
 * Heyoravix Product Recs — progressive enhancement only.
 * The grid/carousel works with pure CSS scroll-snap without this script.
 * This adds: prev/next buttons (shown only when content overflows),
 * a lightweight Quick Add for single-variant products, and Theme Editor
 * block-select scrolling. Scoped per section instance; safe for multiple
 * sections on one page.
 */

(function () {
  function initSection(root) {
    if (root.dataset.hvPrInit === 'true') return;
    root.dataset.hvPrInit = 'true';

    const list = root.querySelector('[data-hv-pr-list]');
    const nav = root.querySelector('[data-hv-pr-nav]');
    const prevBtn = root.querySelector('[data-hv-pr-prev]');
    const nextBtn = root.querySelector('[data-hv-pr-next]');
    if (!list) return;

    function updateNav() {
      if (!nav) return;
      const overflowing = list.scrollWidth > list.clientWidth + 4;
      nav.hidden = !overflowing;
      if (!overflowing) return;
      if (prevBtn) prevBtn.disabled = list.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 4;
    }

    function step(direction) {
      const card = list.querySelector('.hv-pr-card');
      const cardWidth = card ? card.getBoundingClientRect().width : list.clientWidth;
      list.scrollBy({ left: direction * (cardWidth + 20), behavior: 'smooth' });
    }

    prevBtn && prevBtn.addEventListener('click', () => step(-1));
    nextBtn && nextBtn.addEventListener('click', () => step(1));
    list.addEventListener('scroll', () => {
      if (root._hvPrScrollRaf) return;
      root._hvPrScrollRaf = requestAnimationFrame(() => {
        root._hvPrScrollRaf = null;
        updateNav();
      });
    }, { passive: true });

    const resizeObserver = new ResizeObserver(updateNav);
    resizeObserver.observe(list);
    root._hvPrResizeObserver = resizeObserver;

    updateNav();

    // Quick Add for single-variant products.
    function setButtonLabel(button, text) {
      const labelEl = button.querySelector('.hv-pr-quick-add-pill__label');
      if (labelEl) {
        labelEl.textContent = text;
      } else {
        button.textContent = text;
      }
    }

    root.querySelectorAll('[data-hv-quick-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        if (button.dataset.state === 'adding') return;
        const variantId = button.dataset.variantId;
        if (!variantId) return;

        const labelEl = button.querySelector('.hv-pr-quick-add-pill__label');
        const originalLabel = labelEl ? labelEl.textContent : button.textContent;
        button.dataset.state = 'adding';
        button.disabled = true;
        setButtonLabel(button, 'Adding…');

        try {
          const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          const data = await response.json();
          if (!response.ok) {
            throw new Error(data.description || 'Unable to add to cart.');
          }

          setButtonLabel(button, 'Added');

          try {
            const cart = await fetch(`${rootPath}cart.js`).then((r) => r.json());
            document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
              el.textContent = cart.item_count;
            });
          } catch (e) {
            /* non-critical */
          }

          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }

          setTimeout(() => {
            button.removeAttribute('data-state');
            button.disabled = false;
            setButtonLabel(button, originalLabel);
          }, 2000);
        } catch (error) {
          button.removeAttribute('data-state');
          button.disabled = false;
          setButtonLabel(button, originalLabel);
        }
      });
    });

    // Theme Editor: scroll the selected block's card into view.
    root._hvPrOnBlockSelect = (event) => {
      const blockId = event.detail && event.detail.blockId;
      if (!blockId) return;
      const card = root.querySelector('[data-shopify-editor-block="' + blockId + '"]');
      if (card) {
        card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
    };
    document.addEventListener('shopify:block:select', root._hvPrOnBlockSelect);
  }

  function teardownSection(root) {
    if (root._hvPrResizeObserver) root._hvPrResizeObserver.disconnect();
    if (root._hvPrOnBlockSelect) {
      document.removeEventListener('shopify:block:select', root._hvPrOnBlockSelect);
    }
    root.dataset.hvPrInit = 'false';
  }

  function initAll(container) {
    (container || document).querySelectorAll('[id^="HeyoravixProductRecs-"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target && event.target.querySelector
      ? event.target.querySelector('[id^="HeyoravixProductRecs-"]')
      : null;
    if (root) teardownSection(root);
  });
})();
